module.exports = __webpack_public_path__ + "static/media/model-d-max-08.c010719e.jpg";